import { Box, Grid, Typography } from "@mui/material";

const features = [
  {
    title: "Understand Any Document",
    description: `Upload contracts, policies, reports, or manuals – Dokusense instantly becomes your expert reader. Ask natural questions and get precise, contextual answers.`,
  },
  {
    title: "Built-In Anonymization",
    description: `Sensitive data like names, emails, IDs, or financial details? Automatically anonymized. Stay compliant with GDPR, HIPAA, and other data protection standards.`,
  },
  {
    title: "RAG-Powered Intelligence",
    description: `Powered by our proprietary RAG-based reasoning engine – purpose-built to deeply understand and interpret complex PDFs, including images, tables, and charts.`,
  },
  {
    title: "Smart Summarization",
    description: `Summarize long documents or highlight key differences between versions. Generate concise reports or executive briefs from raw materials.`,
  },
  {
    title: "Handle Complex Files",
    description: `Multi-page PDFs, scanned documents, legalese – we make them searchable and understandable. Works across industries: Legal, Insurance, Finance, Healthcare, and more.`,
  },
  {
    title: "Interactive & Transparent AI",
    description: `Ask follow-up questions, explore edge cases, and dive deeper – just like talking to an expert. Get not only answers, but also explanations and document-based evidence for every response.`,
  },
];

export default function FeaturesGrid({ lessThanXL, scrollToBottom }) {
  return (
    <Box
      mt={12}
      sx={{
        paddingLeft: !lessThanXL ? "55px" : "1px",
        paddingRight: !lessThanXL ? "55px" : "1px",
        color: "#1F1F1F",
      }}
    >
      <Box sx={{ paddingLeft: "20px" }}>
        <Typography
          sx={{
            fontSize: !lessThanXL ? "34px" : "32px",
          }}
          component="span"
          fontWeight="700"
          lineHeight={"normal"}
          gutterBottom
        >
          What {""}
        </Typography>

        <Typography
          fontWeight="700"
          component="span"
          sx={{
            fontSize: !lessThanXL ? "34px" : "32px",
            fontStyle: !lessThanXL ? "italic" : "",
            background: (theme) => theme.palette.gradient.toTop,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            lineHeight: "normal",
          }}
        >
          Dokusense Can Do
        </Typography>
      </Box>

      <Box mt={5}>
        <Typography
          fontWeight="400"
          component="div"
          sx={{
            fontSize: "18px",
            lineHeight: "normal",
            paddingLeft: !lessThanXL ? "20px" : "20px",
            paddingRight: !lessThanXL ? "20px" : "20px",
          }}
        >
          DokuSense reads any document, answers your questions, and makes
          complex PDFs easy to navigate. With smart summarization, deep search,
          and automatic anonymization, you stay in control of your data
        </Typography>
      </Box>
      <Grid container>
        {features.map((feature, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={index}
            sx={{
              paddingLeft: "15px",
              paddingRight: "15px",
              marginTop: "30px",
            }}
          >
            <Box
              className="border-box"
              sx={{
                backgroundColor: "#F0EEE6",
                paddingLeft: "20px",
                paddingTop: "30px",
                paddingBottom: "30px",
                paddingRight: "20px",
              }}
            >
              <Typography
                color="#1F1F1F"
                lineHeight={"normal"}
                variant="subtitle1"
                fontWeight="700"
                fontSize="24px"
                gutterBottom
              >
                {feature.title}
              </Typography>
              <Typography
                color="#393939"
                lineHeight={"normal"}
                variant="body2"
                fontSize="18px"
                fontWeight={400}
              >
                {feature.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
